var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#F1F1F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.8405 37.7585C54.7393 35.8597 57.3147 34.793 60 34.793C62.6853 34.793 65.2606 35.8597 67.1595 37.7585C69.0583 39.6573 70.125 42.2327 70.125 44.918V53.25H71.8125C75.5404 53.25 78.5625 56.2721 78.5625 60V78.5625C78.5625 82.2904 75.5404 85.3125 71.8125 85.3125H48.1875C44.4596 85.3125 41.4375 82.2904 41.4375 78.5625V60C41.4375 56.2721 44.4596 53.25 48.1875 53.25H49.875V44.918C49.875 42.2327 50.9417 39.6573 52.8405 37.7585ZM48.1875 56.625C46.3235 56.625 44.8125 58.136 44.8125 60V78.5625C44.8125 80.4265 46.3235 81.9375 48.1875 81.9375H71.8125C73.6765 81.9375 75.1875 80.4265 75.1875 78.5625V60C75.1875 58.136 73.6765 56.625 71.8125 56.625H48.1875ZM66.75 53.25H53.25V44.918C53.25 43.1278 53.9612 41.4109 55.227 40.145C56.4929 38.8791 58.2098 38.168 60 38.168C61.7902 38.168 63.5071 38.8791 64.773 40.145C66.0388 41.4109 66.75 43.1278 66.75 44.918V53.25Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.2449989baec2ac10154fc894296b8052.svg";
export { ForwardRef as ReactComponent };